import { PageInfo } from './page-info.model';
import { Role } from './role.model';


 export class UserRolePagesMapping {
    constructor(
          public id?: number,
          public role?: Role,
          public page?: PageInfo,
          public readOnlySw?: any,
          public navSw?: any,

      ) {
      }
  }


  
    


// WEBPACK FOOTER //
// ./src/app/shared/model/user-role-pages-mapping.model.ts